import { Box, Typography } from '@astro-ui/components'
import theme from '@astro-ui/theme'
import Table from './Table'

const ActivityStaff = () => (
  <Box
    id="aktivitas-staff"
    borderRadius="8px"
    border="1px solid"
    borderColor={theme.colors.border}
    backgroundColor={theme.colors.white}
    overflow="auto"
  >
    <Box display="flex" padding="24px">
      <Typography variant="display-tiny" whiteSpace="nowrap">
        Aktivitas Staff
      </Typography>
    </Box>

    <Table />
  </Box>
)

export default ActivityStaff
